import type { AxiosInstance } from 'axios';
import { fetchDataPreviewsQuery, sendSubmissionQuery } from '@gov-nx/api';
import type { CrzResponse } from '@gov-nx/module/service';
import { GunListType } from '@gov-nx/module/service';

export const crzDataQuery = async (axiosInstance: AxiosInstance) => {
	const { data } = await fetchDataPreviewsQuery(axiosInstance)<
		{ zdrojUdaju: string; varianta: string },
		CrzResponse
	>({
		zdrojUdaju: 'REGISTR_ZBRANI_ZBROJNI_LIST',
		varianta: GunListType.UPLNY,
	});

	return data;
};

export type SubmitMutationVariables =
	| { varianta: GunListType.UPLNY }
	| { varianta: GunListType.CASTECNY; vybraneUdaje: string[] };

export const gunListSubmitMutation = (
	axiosInstance: AxiosInstance,
	variables: SubmitMutationVariables
) =>
	sendSubmissionQuery(axiosInstance)({
		body: {
			kodPodani: 'REGISTR_ZBRANI_ZBROJNI_LIST',
			varianta: variables.varianta,
			vybraneUdaje:
				variables.varianta === GunListType.CASTECNY
					? variables.vybraneUdaje
					: undefined,
		},
	});
